export function hasSessionCookie(name) {
  return document.cookie.split("; ").some((cookie) => cookie === `${name}=true`);
}

export function setSessionCookie(name) {
  document.cookie = `${name}=true; path=/; SameSite=Lax`;
}